import * as React from 'react';
import { HorizontalTabs } from 'damco-components';
import {ITab} from 'constants/costRevModels'
interface ITabParams {
    isDisabled?: boolean,
    disableClick?:boolean,
    name: string,
    navLinks: ITab[],
    count?: boolean,
    className?:string,
    callbackFc?: (e:number) => void,
    activeTab?: number,
    fRef?:any
}
export const TabComponent: React.FunctionComponent<ITabParams> = (props) => {
    const getChildren = (index:number) => {
        if(props.children && Array.isArray(props.children) && props.children[index]){
            return props.children[index]
        }else if(props.children && index === 0 && !Array.isArray(props.children)) {
            return props.children
        }
        return props.navLinks[index].emptyLabel
    }
    const tabs = props.navLinks.map((elTab:any, index:number) =>{
        return <div className="padding-top-large" key={`tab-${index}`}>{getChildren(index)}</div>
    })

    const onChangeNav = (id: any) => {
        if(props.callbackFc){
            props.callbackFc(id)
        }
    }
    return (
        <div className={props.isDisabled? 'disabled-tab': props.className} ref={props.fRef}>
            <HorizontalTabs name={`horizontal-tabs-${props.name}`} 
            onChange={(onChangeNav)} 
            count={props.count} 
            selectedTab={props.activeTab}
            tabData={props.navLinks}>
                {tabs}
            </HorizontalTabs>
        </div>
    );
}